import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { motion } from 'framer-motion';
import axios from 'axios';

const margin = { right: 24 };

export default function SimpleLineChart() {
  const [dailyData, setDailyData] = React.useState([]);
  const [weeklyData, setWeeklyData] = React.useState([]);
  const [xLabels, setXLabels] = React.useState([]);
  const [dateRange, setDateRange] = React.useState({ start: "", end: "" });
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchChartData = async () => {
      try {
        const res = await axios.get("https://prod-erp.nifty10.in/chart-data");
        const chart = res.data?.data;

        if (chart) {
          setXLabels(chart.labels);
          setDailyData(chart.daily);
          setWeeklyData(chart.weekly);
          setDateRange(chart.dateRange || {});
        }
      } catch (error) {
        console.error("Error fetching chart data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  if (loading) return <p>Loading chart...</p>;

  return (
    <div className="chart-container" style={{ marginTop: "20px" }}>
      <div
        className="chart-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>Bank Nifty</h3>
        {dateRange.start && dateRange.end && (
          <span style={{ fontSize: "14px", color: "#555" }}>
            {dateRange.start} - {dateRange.end}
          </span>
        )}
      </div>

      <LineChart
        height={300}
        series={[
          { data: weeklyData, label: 'Weekly Total', color: '#1976d2' },
          { data: dailyData, label: 'Daily Filled Slots', color: '#d32f2f' },
        ]}
        xAxis={[{ scaleType: 'point', data: xLabels }]}
        yAxis={[{ width: 50 }]}
        margin={margin}
        slots={{
          line: AnimatedLine,
          mark: AnimatedMark,
        }}
      />
    </div>
  );
}

function AnimatedLine({ d, ownerState, skipAnimation }) {
  return (
    <motion.path
      d={d}
      fill="transparent"
      stroke={ownerState.color}
      strokeWidth={2}
      initial={{
        pathLength: skipAnimation ? 1 : 0,
        opacity: skipAnimation ? 1 : 0,
      }}
      animate={{ pathLength: 1, opacity: 1 }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
    />
  );
}

function AnimatedMark({ x, y, color, skipAnimation }) {
  return (
    <motion.circle
      cx={x}
      cy={y}
      r={5}
      fill={color}
      initial={{
        scale: skipAnimation ? 1 : 0,
        opacity: skipAnimation ? 1 : 0,
      }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.3, ease: 'backOut' }}
    />
  );
}
